import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, API_ENDPOINTS } from '@pos-app/data';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class EventService {
  navDisable: boolean = false;
  constructor(private config: ConfigService, private http: HttpClient) {}

  //   get(date): Promise<Event[]>{
  //     return
  //     //  firstValueFrom(this.http.get(this.eventUrl))
  //     //     .catch(HandleError);
  //   }

  fetchResourceList(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchResourceList}`, parameters);
  }

  fetchRecordsForBooking(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchRecordsForBooking}`, parameters);
  }

  splitOrder(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.splitOrder}`, parameters);
  }

  consolidateOrder(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.consolidateOrder}`, parameters);
  }

  changeOrderBooking(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.changeOrderBooking}`, parameters);
  }
  renameGroupName(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.renameGroupName}`, parameters);
  }

  fetchOrderFromJDE(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchOrderFromJDE}`, parameters);
  }

  listWorkshopTask(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.listWorkshopTask}`, parameters);
  }

  get(parameters) {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchWeekList}`, parameters);
  }
  insert(parameters): Promise<any> {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.maintainTaskBooking}`, parameters).toPromise();
  }
  update(parameters): Promise<any> {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.maintainTaskBooking}`, parameters).toPromise();
  }
  remove(parameters): Promise<any> {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.maintainTaskBooking}`, parameters).toPromise();
  }
  maintainOrderBooking(parameters): Promise<any> {
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.maintainOrderBooking}`, parameters).toPromise();
  }
  fetchWorkshopHours(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchWorkshopHours}`, parameters);
  }
  fetchScheduledResources (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchScheduledResources}`, parameters);
  }
  listWorkshopOrderStatus (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.listWorkshopOrderStatus}`, parameters);
  }
  changeResourceDescription(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.changeResourceDescription}`, parameters);
  }
  fetchResourceHours(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchResourceHours}`, parameters);
  }
  changeResourceSchedule (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.changeResourceSchedule}`, parameters);
  }
  fetchResourceListV2(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchResourceListV2}`, parameters);
  }
  addResourceToSchedule(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.addResourceToSchedule}`, parameters);
  }
  findSalesOrderInSchedule (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.findSalesOrderInSchedule}`, parameters);
  }
  removeResourceFromSchedule (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.removeResourceFromSchedule}`, parameters);
  }
  fetchOrderDetailsForSplit (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchOrderDetailsForSplit}`, parameters);
  }

  splitOrderV2 (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.splitOrderV2}`, parameters);
  }
  consolidateOrderV2 (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.consolidateOrderV2}`, parameters);
  }
  listWorkshopVehicleStatus (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.listWorkshopVehicleStatus}`, parameters);
  }
  listWorkshopJobTypes(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.listWorkshopJobTypes}`, parameters);
  }
  sendSMSReminderBeforeBooking(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.sendSMSReminderBeforeBooking}`, parameters);
  }
  listWorkshopLegend (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.listWorkshopLegend}`, parameters);
  }
  sendSMSCollectCar(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.sendSMSCollectCar}`, parameters);
  }
  fetchWorkshopOpenDays(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchWorkshopOpenDays}`, parameters);
  }
  changeWorkshopOpenDays(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.changeWorkshopOpenDays}`, parameters);
  }
  fetchOrderDetailsForScheduler(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchOrderDetailsForScheduler}`, parameters);
  }
  fetchOrderLedger(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchOrderLedger}`, parameters);
  }

  fetchRecordsForWeek(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchRecordsForWeek}`, parameters);
  }

  removeOrderFromSchedule (parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.removeOrderFromSchedule}`, parameters);
  }

  
  changeWorkshopTimes(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.changeWorkshopTimes}`, parameters);
  }

  fetchMonthlyViewForOrder(parameters){
    return this.http.post<ApiResponse>(`${this.config.AppConfig.backendUrl}${API_ENDPOINTS.fetchMonthlyViewForOrder}`, parameters);
  }
  
}

